var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import { ColumnItemContainer, ColumnItemInner } from '../style/styled';
import { randomID } from '../../../core/utils';
export var ColumnItem = function ColumnItem(_a) {
  var _size = _a.size,
      id = _a.id,
      props = __rest(_a, ["size", "id"]);

  return React.createElement(ColumnItemContainer, Object.assign({
    id: "rc-columnItem-".concat(id || randomID),
    size: _size
  }, props), React.createElement(ColumnItemInner, Object.assign({}, props)));
};